import { Stack, Alert, Box } from "@mui/material";
import { useMarketStatus } from "../hooks/useMarketStatus";

export default function TopPicks() {
  // const [picks, setPicks] = useState<any[]>([]);
  const { marketStatus } = useMarketStatus();

  return (
    <Stack spacing={2}>
      {/* Market Status Banner */}
      {marketStatus && marketStatus.currentPrice > 0 && (
        <Box sx={{ mb: 2 }}>
          {marketStatus.isBearish ? (
            <Alert severity="error" variant="filled" sx={{ borderRadius: 2 }}>
              ⚠️ <strong>MARKET WARNING:</strong> Nifty 50 is at <strong>{marketStatus.currentPrice.toLocaleString()}</strong>, 
              which is below the EMA 200 (<strong>{marketStatus.ema200.toLocaleString(undefined, { maximumFractionDigits: 0 })}</strong>). 
              Trend is Bearish. <strong>STOP BUYING.</strong>
            </Alert>
          ) : (
            <Alert severity="success" variant="filled" sx={{ borderRadius: 2 }}>
              🟢 <strong>Market is Bullish:</strong> Nifty 50 (<strong>{marketStatus.currentPrice.toLocaleString()}</strong>) 
              is above EMA 200. Safe to trade.
              <span style={{ marginLeft: 15, fontWeight: "bold" }}>
                ({marketStatus.changePercent > 0 ? "+" : ""}{marketStatus.changePercent.toFixed(2)}%)
              </span>
            </Alert>
          )}
        </Box>
      )}

      {/* {picks.length > 0 && (
        <Stack spacing={2}>
           <Box sx={{ color: 'text.secondary', fontWeight: 'bold', mb: 1 }}>TODAY'S TOP PICKS</Box>
           {picks.map((p: any) => (
            <Box key={p.tradingsymbol} sx={{ 
              p: 2, 
              bgcolor: 'background.paper', 
              borderRadius: 2, 
              borderLeft: '4px solid',
              borderColor: p.activeSignal === 'BUY' ? 'success.main' : 'warning.main',
              boxShadow: 1
            }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>
                  <Box sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{p.tradingsymbol}</Box>
                  <Box sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>{p.sector}</Box>
                </Box>
                <Stack direction="row" spacing={1}>
                  <Box sx={{ 
                    px: 1, py: 0.5, borderRadius: 1, 
                    bgcolor: 'primary.main', color: 'white', 
                    fontSize: '0.8rem', fontWeight: 'bold' 
                  }}>
                    Score: {p.compositeScore}
                  </Box>
                  <Box sx={{ 
                    px: 1, py: 0.5, borderRadius: 1, 
                    bgcolor: p.activeSignal === 'BUY' ? 'success.light' : 'warning.light', 
                    color: 'white', 
                    fontSize: '0.8rem', fontWeight: 'bold' 
                  }}>
                    {p.activeSignal}
                  </Box>
                </Stack>
              </Stack>
            </Box>
          ))}
        </Stack>
      )} */}
    </Stack>
  );
}
